import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";

//import DatePicker from "material-ui/DatePicker";
import {
  SelectField,
  TextField,
  DatePicker,
  Checkbox
} from "redux-form-material-ui";
import { connect } from "react-redux";
import MenuItem from "material-ui/MenuItem";
import Subheader from "material-ui/Subheader";
import Fab from "material-ui/FloatingActionButton";
import Check from "material-ui/svg-icons/navigation/check";
import { required } from "../services/form";

import { getKindPrimaryText } from "../utils";
import { merchantCreate, loadCountries } from "./actions";
import { checkPrivileges } from "../auth/privileges";
import auth from "../auth/constants";
import { DateTimeFormat } from "../utils";

const KINDS = [
  "ESF",
  "LIFT",
  "ASSU",
  "HOT",
  "TOURIST_TAX",
  "STAND",
  "SKI_RENTAL"
];

class Create extends Component {
  state = {
    birthcountry: "FR"
  };

  componentDidMount() {
    this.props.loadCountries();

    this.refs.name
      .getRenderedComponent()
      .getRenderedComponent()
      .focus();
  }

  renderPropart = () => {
    const values = this.props.formValues();
    if (values && values.pro) {
      return [
        <Field
          name="siret"
          floatingLabelText="Siret"
          component={TextField}
          validate={required}
          ref="siret"
          key="siret"
          withRef
        />,
        <Field
          name="companyName"
          floatingLabelText="Nom de la société"
          component={TextField}
          validate={required}
          ref="companyName"
          key="companyName"
          withRef
        />,
        <Field
          name="NAFCode"
          floatingLabelText="Code NAF"
          component={TextField}
          validate={required}
          ref="NAFCode"
          key="NAFCode"
          withRef
        />,
        <Field
          name="thirdpartyintroduction"
          floatingLabelText="Tierce introduction"
          component={SelectField}
          validate={required}
          ref="thirdpartyintroduction"
          withRef
        >
          <MenuItem value="0" primaryText="Non tiers introduit" />
          <MenuItem value="1" primaryText="BPAura" />
          <MenuItem value="2" primaryText="BPSavoie" />
        </Field>
      ];
    }
    return null;
  };

  render() {
    const { handleSubmit, user, countries } = this.props;
    return (
      <div className="card-container">
        <div className="card">
          <div className="inner">
            {" "}
            <form onSubmit={handleSubmit}>
              <div className="title">Création du marchand SMoney & ESF+</div>
              <div className="fieldset">
                <Subheader>Marchand ESF +</Subheader>
                <Field
                  name="libelle"
                  floatingLabelText="Nom du marchand"
                  component={TextField}
                  validate={required}
                  ref="name"
                  withRef
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_NAME_FIELD
                    )
                  }
                />
                <Field
                  name="kind"
                  floatingLabelText="Type de marchand"
                  component={SelectField}
                  disabled={
                    !checkPrivileges(
                      user.privileges,
                      auth.MERCHANT_EDIT_KIND_FIELD
                    )
                  }
                  validate={required}
                >
                  <MenuItem />
                  {KINDS.map(kind => {
                    return (
                      <MenuItem
                        key={kind}
                        value={kind}
                        primaryText={getKindPrimaryText(kind)}
                      />
                    );
                  })}
                </Field>
                <Field
                  name="code"
                  floatingLabelText="Code marchand"
                  component={TextField}
                  validate={required}
                />
                <div className="field-spacer" />
                <Subheader>Détenteur du compte smoney</Subheader>
                <Field
                  name="lastname"
                  floatingLabelText="Nom de l'utilisateur"
                  component={TextField}
                  validate={required}
                  ref="lastname"
                  withRef
                />
                <Field
                  name="firstname"
                  floatingLabelText="Prénom de l'utilisateur"
                  component={TextField}
                  validate={required}
                  ref="firstname"
                  withRef
                />
                <Field
                  name="civility"
                  floatingLabelText="Civilité"
                  component={SelectField}
                  validate={required}
                  ref="civility"
                  withRef
                >
                  <MenuItem />
                  <MenuItem value="0" primaryText="Monsieur" />
                  <MenuItem value="1" primaryText="Mlle / Madame" />
                </Field>
                <Field
                  name="birthdate"
                  component={DatePicker}
                  floatingLabelText="Date de naissance"
                  hintText="Date de naissance"
                  validate={required}
                  ref="birthdate"
                  locale={"fr"}
                  format={null}
                  withRef
                  DateTimeFormat={DateTimeFormat}
                />

                <Field
                  name="birthcountry"
                  floatingLabelText="Pays de résidence"
                  component={SelectField}
                  validate={required}
                >
                  <MenuItem />
                  {countries.map(({ code, name }) => {
                    return (
                      <MenuItem key={code} value={code} primaryText={name} />
                    );
                  })}
                </Field>
                <div className="field-spacer" />
                <Subheader>Paramètres SMoney</Subheader>
                <Field
                  name="pro"
                  label="Utilisateur professionnel"
                  component={Checkbox}
                  ref="pro"
                  withRef
                />

                <Field
                  name="appuserid"
                  floatingLabelText="AppUserId"
                  component={TextField}
                  validate={required}
                  ref="appuserid"
                  withRef
                />
                <Field
                  name="appaccountid"
                  floatingLabelText="AppAccountId"
                  component={TextField}
                  validate={required}
                  ref="appaccountid"
                  withRef
                />
                <Field
                  name="email"
                  floatingLabelText="Email"
                  component={TextField}
                  validate={required}
                  ref="email"
                  withRef
                />
                <div className="field-spacer" />

                {this.renderPropart()}
              </div>
              <Fab type="submit" className="fab" secondary>
                <Check />
              </Fab>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

Create = reduxForm({
  form: "Create",
  enableReinitialize: true
})(Create);

/********* Container part */

const mapStateToProps = state => ({
  initialValues: { birthcountry: "FR" },
  user: state.app.auth.user,
  formValues: () => (state.form.Create ? state.form.Create.values : {}),
  resorts: state.merchant.resorts,
  countries: state.merchant.countries,
  merchantList: state.merchant.merchantList
});

const mapDispatchToProps = (dispatch, getState) => ({
  onSubmit: values => {
    const {
      appuserid,
      appaccountid,
      birthcountry,
      birthdate,
      civility,
      companyName,
      NAFCode,
      thirdpartyintroduction,
      email,
      lastname,
      firstname,
      pro,
      siret,
      kind,
      libelle,
      code
    } = values;
    dispatch(
      merchantCreate(
        appuserid,
        appaccountid,
        birthcountry,
        birthdate,
        civility,
        companyName,
        email,
        lastname,
        firstname,
        pro,
        siret,
        kind,
        libelle,
        code,
        NAFCode,
        thirdpartyintroduction
      )
    );
  },
  loadCountries: () => dispatch(loadCountries())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Create);



// WEBPACK FOOTER //
// ./src/merchant/Create.js